goog.provide("shadow.js.shim.module$src$svg$wpp$charts$graph_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$charts$graph_svg");
shadow.js.shim.module$src$svg$wpp$charts$graph_svg = shadow.js.nativeProvides["src/svg/wpp/charts/graph.svg"] = shadow$bridge("src/svg/wpp/charts/graph.svg");
module$shadow_js_shim_module$src$svg$wpp$charts$graph_svg.default = shadow.js.shim.module$src$svg$wpp$charts$graph_svg;
